<template>
  <b-nav-item-dropdown ref="notification-dropdown" class="dropdown-notification mr-25" menu-class="dropdown-menu-media" right @show="onShow">
    <template #button-content>
      <feather-icon v-if="unreadMessagesCount > 0" v-bind:badge="unreadMessagesCount" badge-classes="bg-danger" class="text-body" icon="MessageSquareIcon" size="21"/>
      <feather-icon v-else badge-classes="bg-danger" class="text-body" icon="MessageSquareIcon" size="21"/>
    </template>

  </b-nav-item-dropdown>
</template>

<script>


import { mapActions } from 'vuex'

export default {
  name:"ChatToggler",
  data:()=>({
    unreadMessagesCount:0,
    checkUnreadMessagesInterval:null,
  }),
  created() {
    this.checkUnreadMessages();
    this.checkUnreadMessagesInterval = setInterval(()=>{
      this.checkUnreadMessages();
    },30*1000);
  },
  beforeDestroy() {
    clearInterval(this.checkUnreadMessagesInterval);
  },
  computed:{

  },
  methods: {
    ...mapActions('chat', ['fetchUnreadMessagesCount','getChatMessages']),
    onShow() {
      this.$emit('show');
      this.checkUnreadMessages();
      this.$router.push({ name: 'clientsChat' });
    },
    checkUnreadMessages() {
      this.fetchUnreadMessagesCount().then(count=>{
        this.unreadMessagesCount = count.total;
      });
    }
  }
}
</script>

<style>

</style>
